import { Alert } from 'antd';
import { Smartphone } from 'lucide-react';
import { ConfirmItsYouPanel } from '../../../components/ConfirmItsYouPanel';
import { useTotpEnrollment } from '../hooks/use-totp-enrollment';
import { RecoveryCodesReveal } from './RecoveryCodesReveal';
import { TotpEnrollmentWizard } from './TotpEnrollmentWizard';
import { TwoFactorRow } from './TwoFactorRow';
import { TwoFactorSwitch } from './TwoFactorSwitch';

export function TotpRow({ isOn, canTurnOn }: { isOn: boolean; canTurnOn: boolean }) {
  const { enrollment, error, submitting, confirmation, start, verify, finish, disable, cancel } = useTotpEnrollment();
  const isIdle = enrollment.phase === 'idle' && confirmation.state.phase === 'idle';

  return (
    <TwoFactorRow
      icon={Smartphone}
      title="Authenticator app"
      isOn={isOn}
      description={
        isOn ? 'A code from your authenticator app finishes a password sign-in.' : 'Use a code from an app such as Google Authenticator or 1Password.'
      }
      action={
        isIdle && (
          <TwoFactorSwitch method="the authenticator app" isOn={isOn} canTurnOn={canTurnOn} submitting={submitting} onTurnOn={start} onTurnOff={disable} />
        )
      }
    >
      {isIdle && error && <Alert className="mt-4" type="error" title={error} showIcon />}
      <ConfirmItsYouPanel confirmation={confirmation} />
      {enrollment.phase === 'secret' && (
        <div className="mt-4">
          <TotpEnrollmentWizard
            secret={enrollment.secret}
            qrCodeDataUrl={enrollment.qrCodeDataUrl}
            error={error}
            submitting={submitting}
            onVerify={verify}
            onCancel={cancel}
          />
        </div>
      )}
      {enrollment.phase === 'recovery-codes' && (
        <div className="mt-4">
          <RecoveryCodesReveal codes={enrollment.codes} onDone={finish} />
        </div>
      )}
    </TwoFactorRow>
  );
}
